// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reservation-status-marker[data-v-6dce2502]{border-radius:50%;width:15px;height:15px}.overpaid[data-v-6dce2502]{border:2px solid red}", ""]);
// Exports
module.exports = exports;
